import {
  PropsWithChildren,
  useEffect,
  useRef
} from 'react';

export type ClickOutsideProps = PropsWithChildren<{
  className: string;
  excludeElements?: HTMLElement[];
  onClickOutside: () => void;
}>;

export function ClickOutside({
  className,
  onClickOutside,
  excludeElements = [],
  children
}: ClickOutsideProps) {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      !wrapperRef.current ||
      wrapperRef.current.contains(event.target as Node) ||
      excludeElements.some((element) => element.contains(event.target as Node))
    ) {
      return;
    }
    onClickOutside();
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className={className} ref={wrapperRef}>
      {children}
    </div>
  );
}
